import styles from "./analytics-metrics.module.css"

export default function MetricsCards({ data }) {
  return (
    <div className={styles.metricsGrid}>
      <div className={styles.section}>
        <h2>Today</h2>
        <div className={styles.cards}>
          <MetricCard label="Revenue" value={`₹${data?.today.totalRevenue.toLocaleString()}`} />
          <MetricCard label="Profit" value={`₹${data?.today.totalProfit.toLocaleString()}`} />
          <MetricCard label="Orders" value={data?.today.orderCount} />
          <MetricCard label="Margin" value={`${data?.today.profitMargin}%`} />
        </div>
      </div>

      <div className={styles.section}>
        <h2>This Month</h2>
        <div className={styles.cards}>
          <MetricCard label="Revenue" value={`₹${data?.thisMonth.totalRevenue.toLocaleString()}`} />
          <MetricCard label="Profit" value={`₹${data?.thisMonth.totalProfit.toLocaleString()}`} />
          <MetricCard label="Orders" value={data?.thisMonth.orderCount} />
          <MetricCard label="Margin" value={`${data?.thisMonth.profitMargin}%`} />
        </div>
      </div>

      <div className={styles.section}>
        <h2>All Time</h2>
        <div className={styles.cards}>
          <MetricCard label="Revenue" value={`₹${data?.allTime.totalRevenue.toLocaleString()}`} />
          <MetricCard label="Profit" value={`₹${data?.allTime.totalProfit.toLocaleString()}`} />
          <MetricCard label="Orders" value={data?.allTime.orderCount} />
          <MetricCard label="Margin" value={`${data?.allTime.profitMargin}%`} />
        </div>
      </div>
    </div>
  )
}

function MetricCard({ label, value }) {
  return (
    <div className={styles.metricCard}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value}</span>
    </div>
  )
}
